import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";

export const cioanalytics = AnalyticsBrowser.load(
  {
    writeKey: process.env.VUE_APP_CUSTOMERIO_WRITEKEY,
  },
  {
    integrations: {
      "Customer.io In-App Plugin": {
        siteId: process.env.VUE_APP_CUSTOMERIO_SITEID_PAYJOY,
      },
    },
  }
);
